<template>
	<div class="position-relative">
	    <transition name="vue-table-loader">
	        <div class="vue-table-loader"v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Past Matches"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
		    <vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				pagination-path=""
				noDataTemplate="No Previous Matches Found"
				:append-params="moreParams"
				@vuetable:pagination-data="onPaginationData"
				@vuetable:loaded="onLoaded"
		    >
	    	    <template slot="actions" slot-scope="props">
	    	    	<div class="action-container clearfix">
		    	    	<transition v-bind:name="confirmDelete.transitionValue">
			    	    	<div v-if="confirmDelete.id == props.rowData.id" class="btn-group btn-confirm-delete">
			    	    		<a class="btn btn-danger" :href="'/product_matching/'+props.rowData.id+'/delete_match'"><span>Confirm</span>	</a>
			    	    		<div class="btn btn-outline-danger" @click="cancelDeletion()"><i class="fa fa-times" aria-hidden="true"></i></div>
			    	    	</div>

			    	    	<button class="btn btn-danger btn-start-confirmation" @click="confirmDeletion(props.rowData.id)" v-if="confirmDelete.id != props.rowData.id"><span>Delete</span>	</button>
			    		</transition>
	    	    	</div>
		    	</template>


		    	<template slot="channels" slot-scope="props">
		    			<div class="channel-container" v-if="props.rowData.product_data_count > 0">
		    				<a href="#" v-if="props.rowData.product_data_count > 3" class="channel-expander" v-bind:class="{ scrolled: props.rowData.product_data_count > 10 }" v-on:click.stop="expandChannelsList"></a>
		    				<div class="channel-item-container"  v-bind:class="{ scrolled: props.rowData.product_data_count > 10 }">
		    					<div class="channel-item"  v-for="(index, data) in props.rowData.product_data"><strong>{{data}}:</strong> {{index}} </div>
		    				</div>
		    			</div>
		    	</template>

		    	<template slot="product" slot-scope="props">
		    			<a :href="'/products/' + props.rowData.pim_product_id + '/edit'"><strong>{{props.rowData.product.name}}</strong></a>
		    			<div><strong>Sku:</strong> {{props.rowData.product.sku}}</div>
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style lang="scss">
	.w118{
		width: 118px;
	}
	.w68{
		width: 68px;
	}
	.w45p{
		width: 45%;
	}
	.table-column-no-padding{
		padding: 0 !important;
	}
</style>
<style scoped lang="scss">
	.btn-confirm-delete{
		.btn{
			padding: 11px 8px 9px 8px;
			&:last-child{
				z-index: 10;
				// border-left:1px solid #ff9a9a;
			}
		}
	}
	.action-container{
		position: relative;
		float: right;
		overflow: hidden;
		height: 38px;
		width: 88px;
		background-color: #ef534f;
		border-radius: 2px;
		.btn-confirm-delete, .btn-start-confirmation{
			position: absolute;
			top: 0;
		}
	}
	.slide-reverse-leave-active,
	.slide-reverse-enter-active,
	.slide-leave-active,
	.slide-enter-active {
	  transition: 0.4s;
	}
	.slide-enter {
	  transform: translate(-100%, 0);
	  span{
	  	transition: opacity 0.4s;
	  	opacity: 1;
	  }
	}
	.slide-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	  transform: translate(100%, 0);
	}
	.slide-reverse-enter {
	  transform: translate(100%, 0);
	  span{
	  	transition: opacity 0.4s;
	  	opacity: 1;
	  }
	}
	.slide-reverse-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	  transform: translate(-100%, 0);
	}


	.mr7{
		margin-right: 7px;
	}
	.mr2{
		margin-right: 2px;
	}
	.table-button-container{
		text-align: center;
	}
	.channel-container{
		position: relative;
		.channel-expander{
			background: #25628F;
			z-index:2;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			color:#fff;
			position: absolute;
			text-align: center;
			right: 5px;
			bottom: 3px;
			font-size: 10px;
			padding-top: 1px;
			&:before{
				content: "\F110";
				font: normal normal normal 14px/1 "LineAwesome";
				color: #fff;
     			font-size: 10px;
			}
			&.open{
				&.scrolled{
					right: 7px;
				}
				&:before{
					content:"\f113";
				}
			}
		}
	}
	.channel-item-container{
		transition: all 0.3s;
		z-index:1;
		max-height: 59px;
		min-height: 59px;
		overflow:hidden;
		&.open{
			transition: all 0.5s;
			max-height: 199px;
		}
		&.scrolled{
			overflow-y:overlay;
		}
		&::-webkit-scrollbar {
		    width: 4px;
		}
		&::-webkit-scrollbar-track {
		    background: rgba(0,0,0,0.1);
		    position: absolute;
		    top: 0px;
		    bottom: 0px;
		    right: 0px;
		}
		&::-webkit-scrollbar-thumb {
		    background: #25628F;
		    border-radius:2px;
		}
		&::-webkit-scrollbar-thumb:hover {
		    background: #25628F;
		}
	}
	.channel-item{
		border-bottom:1px solid #dee0e1;
		padding: 2px 7px;
		font-size: 10px;
		position: relative;
		&:nth-child(n+3):last-child{
			border-color:transparent;
		}
	}
	.no-channel{
		text-align: center;
		padding: 20px 0;
	}
</style>

<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host
	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import moment from 'moment';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';
	Vue.use(VueEvents)
	export default {
	    name: 'product-matching-listing',
	    props: [],
	    components:{
	     	'base-filter-bar': BaseFilterBar,
	     	'base-pagination': BasePagination,
	     	'base-pagination-info': BasePaginationInfo,
	     	'base-select-visible': BaseSelectVisible,
	    },
	    data() {
	    	return {
	    		perPage: 10,
	    		moreParams: {},
	    		loading: true,
				fields: [
					{
						name: '__slot:product',
						title: 'Product',
					},
					{
						name: 'source.name',
						title: 'Source',
					},
					{
						name: '__slot:channels',
						title: 'Product Data',
						dataClass: 'table-column-no-padding w45p',
					},
					{
						name: 'created_at',
						title: 'Matched at',
						sortField: 'created_at',
						callback: 'formatDate',
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				confirmDelete:{
					id: null,
					transitionValue: 'slide',
					isActive: false,
				},
				grid: base_url + "/product_matching/grid",
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
	    },
	    mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
	    methods: {
	    	overrideBadge (value) {
			 	return value == '0'
			   		? '<div class="badge badge-success">Yes</div>'
			   		: '<div class="badge badge-danger">No</div>'
			},
			formatDate (value) {
				if (value === null) {
					return 'Never';
				}
			 	return moment(value).format("MMM Do YY");
			},
	        onPaginationData (paginationData) {
	          	this.$refs.pagination.setPaginationData(paginationData)
	          	this.$refs.paginationInfo.setPaginationData(paginationData)
	        },
	        onChangePage (page) {
	          	this.$refs.vuetable.changePage(page)
	        },
	        expandChannelsList () {
	        	$(event.target).next().toggleClass('open')
	        	$(event.target).toggleClass('open')
	        },
	        editRow(rowData){
	        	console.log(rowData);
	        },
	        doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            confirmDeletion (id) {
            	if (this.confirmDelete.isActive == true) {
    	          	this.cancelDeletion()
            	}else{
    				this.confirmDelete.isActive = true;
    			  	this.confirmDelete.id = id;
    			  	this.confirmDelete.transitionValue = 'slide-reverse'
            	}
            },
    		cancelDeletion () {
    			this.confirmDelete.isActive = false;
    			this.confirmDelete.transitionValue = 'slide'
              	this.confirmDelete.id = null;
            },
            onLoaded: function () {
                this.loading = false;
            }
		}
	};
</script>